import { type AppState, type Selector } from '../rootReducer';
import { type ReAssignState } from './types';

export const getStates: Selector<ReAssignState> = (state: AppState) => state.reAssign;
